import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaIcon } from '@rds-nova/angular-icon';

import { SUPPORT_PHONE_NUMBER } from 'src/app/core/constants/support';

@Component({
  selector: 'app-invalid-link',
  imports: [TranslatePipe, NovaIcon],
  templateUrl: './invalid-link.component.html',
  styleUrl: './invalid-link.component.scss',
})
export class InvalidLink {
  protected readonly phoneNumber = SUPPORT_PHONE_NUMBER;
}
